import React from "react"
import { Grid2 } from "@mui/material"
import { MessageCircle as MessageCircleIcon } from "lucide-react"

import { PrimitiveButton } from "@/primitives/PrimitiveButton"
import useStyles from "@/components/Sidebar/InboxButton/styles"

type InboxButtonProps = {
	onClick: () => void
	isCollapsed: boolean
}

export const InboxButton = ({ onClick, isCollapsed }: InboxButtonProps) => {
	const classes = useStyles()

	const containerSx = [classes.container, isCollapsed && classes.containerCollapsed]
	const buttonSx = [classes.button, isCollapsed && classes.buttonCollapsed]

	return (
		<Grid2 size={12} sx={containerSx}>
			<PrimitiveButton
				variant="outlined"
				size="medium"
				onClick={onClick}
				startIcon={!isCollapsed ? <MessageCircleIcon size={20} /> : undefined}
				sx={buttonSx}
			>
				{isCollapsed ? <MessageCircleIcon size={20} /> : "Ir para o inbox"}
			</PrimitiveButton>
		</Grid2>
	)
}
